export default __webpack_public_path__ + "static/media/9.e17f0778.png";